import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MATERIALS as BASE_MATERIALS } from "@/components/RazrezConfigurator";

const SHEET_CATEGORIES = ["iverali", "delovne-plosce"];

export function parseDims(dimensions) {
  if (!dimensions) return null;
  const nums = dimensions.match(/\d+/g);
  if (!nums || nums.length < 2) return null;
  return { w: parseInt(nums[0], 10), h: parseInt(nums[1], 10) };
}

export function getSheetInfo(p) {
  if (!SHEET_CATEGORIES.includes(p.category)) return null;
  const dims = parseDims(p.dimensions);
  if (!dims || !p.price) return null;
  const areaM2 = (dims.w * dims.h) / 1e6;
  if (p.category === "delovne-plosce") {
    const lengthM = dims.w / 1000;
    return {
      mode: "tm",
      areaM2,
      lengthM,
      unitPrice: p.price / lengthM,
      oldUnitPrice: p.old_price ? p.old_price / lengthM : null,
    };
  }
  return {
    mode: "m2",
    areaM2,
    unitPrice: p.price / areaM2,
    oldUnitPrice: p.old_price ? p.old_price / areaM2 : null,
  };
}

let cache = null;

export function useMaterials() {
  const [materials, setMaterials] = useState(cache || BASE_MATERIALS);
  useEffect(() => {
    if (cache) return;
    api.get("/products")
      .then((r) => {
        const derived = r.data
          .filter((p) => SHEET_CATEGORIES.includes(p.category))
          .map((p) => {
            const dims = parseDims(p.dimensions);
            if (!dims) return null;
            const areaM2 = (dims.w * dims.h) / 1e6;
            return {
              id: `art-${p.id}`,
              name: p.name,
              priceM2: Math.round((p.price / areaM2) * 100) / 100,
              panelW: dims.w,
              panelH: dims.h,
              fromArticle: true,
            };
          })
          .filter(Boolean);
        cache = [...BASE_MATERIALS, ...derived];
        setMaterials(cache);
      })
      .catch(() => {});
  }, []);
  return materials;
}
